import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import PublicLayout from "./components/PublicLayout";
import Dashboard from "./components/Dashboard";
import AgentList from "./components/AgentList";
import RegisterAgent from "./components/RegisterAgent";
import Register from "./components/Register";
import Login from "./components/Login";
import ComingSoon from "./components/ComingSoon";
import AgentDetail from "./components/AgentDetail";
import UserList from "./components/UserList";
import AddUser from "./components/AddUser";
import LogList from "./components/LogList";
import History from "./components/History";
import AgentValidation from "./components/AgentValidation";
import ProtectedRoute from "./components/ProtectedRoute";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Flip}
      />
      <Routes>
        {/* Public Routes */}
        <Route
          path="/agents/:id"
          element={
            <PublicLayout>
              <AgentDetail />
            </PublicLayout>
          }
        />
        <Route
          path="/agents/:id/history"
          element={
            <PublicLayout>
              <History />
            </PublicLayout>
          }
        />
        <Route path="/register" element={<Register />} />
        <Route path="/signin" element={<Login />} />
        <Route
          path="/privacy-policy"
          element={<ComingSoon title="Privacy Policy" />}
        />
        <Route
          path="/terms"
          element={<ComingSoon title="Terms & Conditions" />}
        />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <Layout>
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            </Layout>
          }
        />
        <Route
          path="/register-agent"
          element={
            <Layout>
              <ProtectedRoute>
                <RegisterAgent />
              </ProtectedRoute>
            </Layout>
          }
        />
        <Route
          path="/agents"
          element={
            <Layout>
              <ProtectedRoute>
                <AgentList />
              </ProtectedRoute>
            </Layout>
          }
        />
        <Route
          path="/agents/:id/validate"
          element={
            <Layout>
              <ProtectedRoute requiredRole="Moderator">
                <AgentValidation />
              </ProtectedRoute>
            </Layout>
          }
        />
        <Route
          path="/users"
          element={
            <Layout>
              <ProtectedRoute requiredRole="Admin">
                <UserList />
              </ProtectedRoute>
            </Layout>
          }
        />
        <Route
          path="/add-user"
          element={
            <Layout>
              <ProtectedRoute requiredRole="Admin">
                <AddUser />
              </ProtectedRoute>
            </Layout>
          }
        />
        <Route
          path="/logs"
          element={
            <Layout>
              <ProtectedRoute requiredRole="Admin">
                <LogList />
              </ProtectedRoute>
            </Layout>
          }
        />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  );
}

export default App;
